module.exports = __webpack_public_path__ + "img/liotron_100ah_24v.4fc11c90.png";